module.exports = __webpack_public_path__ + "img/builder-27.e4c0dece.webp";